import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useDrone');

    return {
        CONNECTION_ERROR: t('connectionError'),
        DRONE_NAME_DUPLICATE_ERROR: t('droneNameDuplicateError'),
        SAVE_FAILED: t('saveFailed')
    };
};

export default useTranslation;
